export const SET_POSTS = 'SET_POSTS';
export const SET_CHARA = 'SET_CHARA';
export const SET_HIDDENPOSTS = 'SET_HIDDENPOSTS';
export const SET_PRODUCT_CREATION_PENDING = 'setProductCreationPending';
export const ADD_PRODUCT = 'setProductCreationPending';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_RANDOMPOST = 'SET_RANDOMPOST';
export const SET_DESC = 'SET_DESC';
export const SET_NAME = 'SET_NAME';
export const SET_WEBSITE = 'SET_WEBSITE';
export const SET_ACTIVE = 'SET_ACTIVE';
export const UPDATE_PRODUCTS = 'UPDATE_PRODUCTS';

export default {
    [SET_POSTS](state, val) {
        if (val) {
            state.posts = val;
        } else {
            state.posts = [];
        }
    },
    [SET_CHARA](state, val) {
        if (val) {
            state.chara = val;
        } else {
            state.chara = [];
        }
    },
    [SET_HIDDENPOSTS](state, val) {
        if (val) {
            if (!state.hiddenPosts.some(x => x.id === val.id)) {
                state.hiddenPosts.unshift(val);
            }
        } else {
            state.hiddenPosts = [];
        }
    },
    [SET_ACTIVE]: (state, product) => (state.active = product),
    // products
    [SET_PRODUCTS]: (state, products) => {
        state.products = products
    },
    // random post
    [SET_RANDOMPOST]: (state, products) => (state.randomPost = products),
    // update desc
    [SET_DESC]: (state, product) => {
        const index = state.products.findIndex(post => post.uuid === product.uuid);

        state.productDeletionPending.splice(index, 1, product);
    },
    // update name
    [SET_NAME]: (state, product) => {
        const index = state.products.findIndex(post => post.uuid === product.uuid);

        state.productDeletionPending.splice(index, 1, product);
    },
    // update website
    [SET_WEBSITE]: (state, product) => {
        const index = state.products.findIndex(post => post.uuid === product.uuid);

        state.productDeletionPending.splice(index, 1, product);
    },
    /* Product input name */
    setProductNameToCreate: (state, productNameToCreate) =>
        (state.productNameToCreate = productNameToCreate),

    /* Products */
    addProduct: (state, product) => state.products.push(product),
    addProductPosts: (state, product) => state.posts.push(product),
    removeProductById: (state, productId) => {
        const index = state.products.findIndex(
            product => product.uuid === productId
        );
        state.products.splice(index, 1);
    },

    /* Products deletion */
    addProductDeletionPending: (state, productId) =>
        state.productDeletionPending.push(productId),
    removeProductDeletionPending: (state, productId) => {
        const index = state.products.findIndex(
            product => product.id === productId
        );
        state.productDeletionPending.splice(index, 1);
    },

    /* Product creation */
    setProductCreationPending: (state, value) =>
        (state.productCreationPending = value),
};